// extracted by mini-css-extract-plugin
export default {"addressTextBlock":"styles_addressTextBlock__2jKYO","mainText":"styles_mainText__-pzOp","secondaryText":"styles_secondaryText__sNWEu"};